import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { addReport } from "./Constants";
import { Reports } from "./Reports";

export const AddReport = () => {
  let { type } = useParams();
  let params = useParams();
  const history = useHistory();

  const onBackHandler = () => {
    if (history) history.push(`/FaultReporter/admin/${type}`);
  };

  const onSaveHandler = () => {
    alert('Save')
  };

  const addReportValues = {
    data: addReport,
    onBack: onBackHandler,
    onSave: onSaveHandler,
    isArchive: params.isArchive === "live" ? 0 : 1
  };

  return (
    <Reports {...addReportValues} />
  );
};
